import React, {FC, useEffect, useState} from 'react';
import {Announcements, Icon} from 'components';
import {Props, isAnnouncement} from './announcement';
import {over, filter, modal, moment, range, chain} from 'helpers';
import {store, settings} from 'store';
import css from './announcement.module.scss';

export const Manager = () => {
  useEffect(() => {
    const matched = filter(Announcements, item => isAnnouncement(item) && item.prototype.eligible(store.getState()));
    if (matched.length > 0) {
      modal(ModalWindow, {
        Announcements: matched,
        dismissible: false
      })();
    }
  }, []);
  return null;
};

const ModalWindow = ({Announcements, modal}: {Announcements: Array<FC<Props>>}) => {
  const [index, setIndex] = useState(0);
  const Current = Announcements[index];
  const isLast = index + 1 === Announcements.length;
  const inc = () => setIndex(index + 1);

  const next = () => {
    settings.set({
      module: 'announcements',
      key: Current.name,
      value: moment().unix()
    });
  };

  const decline = () => {
    settings.set({
      module: 'announcements',
      key: Current.name,
      value: -1
    });
  };

  return (
    <>
      <Current
        next={over(next, modal.bounce, isLast ? modal.close : inc)}
        decline={over(decline, modal.bounce, isLast ? modal.close : inc)}
        isLast={isLast}
      />
      {Announcements.length > 1 &&
        <div className={css.bullets}>
          {range(0, Announcements.length).map(i =>
            <Icon name="bullet" key={i} aria-current={i === index ? 'step' : undefined} />
          )}
        </div>
      }
    </>
  );
};
